module.exports = __webpack_public_path__ + "img/home-service-SAAS.e95cc400.png";